module.exports = __webpack_public_path__ + "img/modular_settlement_examine@2x.cd61a48e.png";